import React from "react";
import ReactDOM from "react-dom/client";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import "./styles/brand.css";
import "./index.css";
import App from "./App";

dayjs.locale("pt-br");

// `/` ships prerendered markup in #root (scripts/prerender.js) so crawlers and
// the first paint get real content. We client-render over it rather than
// hydrate: the prerender is a DOM dump, so it lacks the text-node markers
// hydration needs and every adjacent-text JSX node would mismatch. React clears
// and re-inserts in a single commit, so there is no flash.
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
